import * as yup from 'yup';

export const scheme = yup
  .object({
    missionCategory: yup.string().required('Mission category is required'),
    missionName: yup.string().required('Mission name is required'),
    missionDescription: yup
      .string()
      .required('Mission description is required'),
    missionType: yup.string().required('Mission type is required'),
    trigger: yup
      .number()
      .min(1, 'Trigger must be a number and more than 0')
      .required('Trigger is required'),
    targetAudience: yup
      .array()
      .of(yup.string().required())
      .required('Target Audience is required'),
    // badgeID: yup.string().required('Badge ID is required'),
    rewardPoint: yup
      .number()
      .min(0, 'Reward point must be a number and more than or equal to 0')
      .required('Reward point is required'),
    rewardXP: yup
      .number()
      .min(0, 'Reward XP must be a number and more than or equal to 0')
      .required('Reward XP is required'),
    multiplierPoint: yup
      .number()
      .min(0, 'Multiplier point must be a number and more than or equal to 0')
      .required('Multiplier point is required'),
    pointExpired: yup.string().required('Point expired is required'),
    startDate: yup.string().required('Start date is required'),
    endDate: yup.string().required('End date is required')
  })
  .required();
